export const RegistryReferer = {
  //   1, // 游戏内-开发者悬浮窗
  // 2 , // 游戏内-创作中心-认证拍脸图
  // 3, // 游戏内-首页-邮件推送
  Home: 4, // 端外-创作者中心-首页
  MapData: 5, // 端外-创作者中心-地图数据
  Settlement: 6, // 端外-创作者中心-个人结算中心
  Equity: 7, // 端外-创作者中心-账号权益
};
